export default "__VITE_ASSET__73954933__"